import { isEqual } from "lodash";
import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import URI from "urijs";
import {bool} from "prop-types";

type ValueType = string[] | string | undefined | boolean;

export interface IQuery {
    [key: string]: ValueType;
}

interface QueryStringFiltersOwnProps<TFilter, TQuery> {
    filter: TFilter;
    getQuery: (filter: TFilter) => TQuery;
    getFilter: (query: TQuery) => TFilter;
    onFilterChange: (filter: TFilter) => void;
}

export type QueryStringFiltersProps<TFilter, TQuery> = QueryStringFiltersOwnProps<TFilter, TQuery> & RouteComponentProps<any>;

class QueryStringFiltersInternal<TFilter extends object, TQuery extends IQuery> extends React.Component<QueryStringFiltersProps<TFilter, TQuery>> {
    constructor(props: QueryStringFiltersProps<TFilter, TQuery>) {
        super(props);

        this.updateFiltersFromQueryString(props.location.search, false);
    }

    public UNSAFE_componentWillReceiveProps(props: QueryStringFiltersProps<TFilter, TQuery>) {
        if (!isEqual(props.filter, this.props.filter)) {
            this.updateQueryStringFromFilters(props.filter);
            return;
        }

        if (props.location.search !== this.props.location.search) {
            this.updateFiltersFromQueryString(props.location.search, true);
        }
    }

    public render(): string {
        return null;
    }

    private updateQueryStringFromFilters(filter: TFilter) {
        const query = this.props.getQuery(filter);
        const queryString = convertQueryToQueryString(query);

        if (this.props.location.search !== queryString) {
            const location = { ...this.props.history, search: queryString };
            this.props.history.replace(location);
        }
    }

    private updateFiltersFromQueryString(queryString: string, notifyIfChangedOnly: boolean) {
        const query = URI(queryString).search(true) as TQuery;
        const filter = this.props.getFilter(query);
        if (!notifyIfChangedOnly || !isEqual(filter, this.props.filter)) {
            this.props.onFilterChange(filter);
        }
    }
}

export function convertQueryToQueryString<TQuery extends IQuery>(query: TQuery): string {
    const normalisedQuery = normaliseQuery(query);
    return new URI().search(normalisedQuery as object).search();
}

export function normaliseQuery<TQuery extends IQuery>(query: TQuery): { [key in keyof TQuery]?: ValueType } {
    const normalisedQuery: { [key in keyof TQuery]?: ValueType} = {};
    for (const key in query) {
        if (!query.hasOwnProperty(key)) {
            continue;
        }

        const value = query[key];

        normalisedQuery[key] = value instanceof Array ? (value.length ? value : undefined) : value || undefined;
    }

    return normalisedQuery;
}

export class QueryStringFilters {
    static For<TFilter extends object, TQuery extends IQuery>() {
        class QueryStringFiltersFor extends QueryStringFiltersInternal<TFilter, TQuery> {}
        return withRouter(QueryStringFiltersFor);
    }
}
